import useSWR from 'swr';
import { apiBaseURL } from '../../Utils/ProjectConstants';


export default function useGetDeliveryLocations() {

    const { data, error, mutate, isLoading } = useSWR(`${apiBaseURL}/api/deliveryLocation`, {
        //onSuccess: (data) => console.log('delivery locations fetched successfully:', data?.data),
        revalidateOnFocus: false,
        dedupingInterval: 300000,
    });

    const deliveryLocations = data?.data;

    return {
        deliveryLocations,
        isLoading,
        error,
        mutate,
    };
}